import React, { useMemo } from 'react';

import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import { getTranslate } from 'react-localize-redux';

type Props = ReturnType<typeof mapProps>;
const mapProps = (state: AppState) => {
  return {
    translate: getTranslate(state),
  };
};

const LegalLink: React.FC<{
  children: any;
  href: string;
}> = ({ children, href }) => {
  return (
    <Link href={href} rel="noopener noreferrer" target="_blank">
      {children}
    </Link>
  );
};

const TC_PLACEHOLDER = '{0}';
const PP_PLACEHOLDER = '{1}';

const AcceptLegal: React.FC<Props> = ({ translate }) => {
  const pp = translate('Privacy_Policy');
  const tc = translate('Terms_and_Conditions');
  const tcUrl = translate('Terms_and_Conditions_URL') as string;
  const ppUrl = translate('Privacy_Policy_URL') as string;
  const text = translate('Accept_Privacy_Policy_Terms_and_Conditions') as string;
  const { accept, acknowledge, more } = useMemo(() => {
    const [accept, rest] = text.split(TC_PLACEHOLDER);
    const [acknowledge, more] = rest.split(PP_PLACEHOLDER);

    return {
      accept,
      acknowledge,
      more,
    };
  }, [text]);

  return (
    <Typography variant="caption">
      {accept}
      <LegalLink href={tcUrl}>{tc}</LegalLink>
      {acknowledge}
      <LegalLink href={ppUrl}>{pp}</LegalLink>
      {more}
    </Typography>
  );
};

export default AcceptLegal;
